export enum EKwikUIInputRadioSize {
  M = "m",
  L = "l"
}
export const VKwikUIInputRadioSize = [
  EKwikUIInputRadioSize.M,
  EKwikUIInputRadioSize.L
] as const;

export type TKwikUIInputRadioSize = (typeof VKwikUIInputRadioSize)[number];

export enum EKwikUIInputRadioOrientation {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal"
}
export const VKwikUIInputRadioOrientation = [
  EKwikUIInputRadioOrientation.HORIZONTAL,
  EKwikUIInputRadioOrientation.VERTICAL
] as const;

export type TKwikUIInputRadioOrientation =
  (typeof VKwikUIInputRadioOrientation)[number];
